import universalLocalStorage from "../../utils/lib/universalLocalStorage";

export default async function saveUserAuth(data) {
  if (data) {
    await universalLocalStorage.setItem("wellness-token", data.token);
    await universalLocalStorage.setItem("wellness-userID", data.userID);
    window.location = "/";
  }
}
